import React from "react";
import { Plus, Trash2 } from "lucide-react";

export default function StandInsBackgroundSection({
  form,
  onAdd,
  onUpdate,
  onDelete,
  inputCls,
  Section,
}) {
  const rows = form.stand_ins_background || [];
  const groupedRows = [
    {
      type: "stand_in",
      label: "STAND-INS",
      placeholder: "Stand-in for principal",
      rows: rows.map((row, index) => ({ row, index })).filter(({ row }) => row.type !== "background"),
    },
    {
      type: "background",
      label: "BACKGROUND",
      placeholder: "Background group or performer",
      rows: rows.map((row, index) => ({ row, index })).filter(({ row }) => row.type === "background"),
    },
  ];

  const renderGroup = ({ type, label, placeholder, rows: groupRows }) => {
    if (groupRows.length === 0) return null;
    return (
      <div key={type} className="overflow-x-auto">
        <table className="w-full min-w-[560px] text-xs">
          <thead>
            <tr className="border-b border-[#28303F]">
              {[["QTY", "16%"], [label, "52%"], ["ARRIVE", "16%"], ["RDY", "16%"], ["", "1%"]].map(
                ([header, width]) => (
                  <th
                    key={header || "actions"}
                    style={{ width }}
                    className="pb-2 pr-2 text-left font-medium text-gray-500"
                  >
                    {header}
                  </th>
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {groupRows.map(({ row, index }) => (
              <tr
                key={index}
                data-testid={`standins-background-row-${type}`}
                className="border-b border-[#28303F]/50"
              >
                <td className="py-1 pr-2">
                  <input
                    data-testid={`standins-background-qty-${index}`}
                    value={row.qty}
                    onChange={(event) => onUpdate(index, "qty", event.target.value)}
                    className={inputCls}
                    placeholder="2"
                  />
                </td>
                <td className="py-1 pr-2">
                  <input
                    data-testid={`standins-background-description-${index}`}
                    value={row.description}
                    onChange={(event) => onUpdate(index, "description", event.target.value)}
                    className={inputCls}
                    placeholder={placeholder}
                  />
                </td>
                <td className="py-1 pr-2">
                  <input
                    data-testid={`standins-background-arrive-${index}`}
                    value={row.arrive}
                    onChange={(event) => onUpdate(index, "arrive", event.target.value)}
                    className={inputCls}
                    placeholder="07:00"
                  />
                </td>
                <td className="py-1 pr-2">
                  <input
                    data-testid={`standins-background-rdy-${index}`}
                    value={row.rdy}
                    onChange={(event) => onUpdate(index, "rdy", event.target.value)}
                    className={inputCls}
                    placeholder="07:30"
                  />
                </td>
                <td className="py-1">
                  <button
                    type="button"
                    data-testid={`standins-background-delete-${index}`}
                    onClick={() => onDelete(index)}
                    className="p-1 text-gray-600 hover:text-red-400"
                    title="Remove row"
                  >
                    <Trash2 size={13} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <Section title="Stand Ins & Background" defaultOpen={rows.length > 0}>
      <div className="space-y-2 pt-4">
        {groupedRows.map(renderGroup)}
        <div className="mt-2 flex flex-wrap gap-3">
          <button
            type="button"
            data-testid="standins-add-button"
            onClick={() => onAdd("stand_in")}
            className="flex items-center gap-2 text-sm text-amber-400 transition-colors hover:text-amber-300"
          >
            <Plus size={15} /> Add Stand In
          </button>
          <button
            type="button"
            data-testid="background-add-button"
            onClick={() => onAdd("background")}
            className="flex items-center gap-2 text-sm text-amber-400 transition-colors hover:text-amber-300"
          >
            <Plus size={15} /> Add Background
          </button>
        </div>
      </div>
    </Section>
  );
}